module.exports = __webpack_public_path__ + "static/media/illy_logo.6d180a69.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/illy_logo.png
// module id = 734
// module chunks = 0